import { Component, input } from '@angular/core';

@Component({
  selector: 'ui-no-data',
  imports: [],
  templateUrl: './no-data.component.html',
})
export class NoDataComponent {
  readonly message = input('No data found');
}
